export default __webpack_public_path__ + "images/LQ.5eb362a.png";